// extracted by mini-css-extract-plugin
export default {"card":"CardLink_card__IG6uf","text":"CardLink_text__9Ts0u"};